(() => {
  const entityDecoder = document.createElement('textarea');
  const decodeTranslation = value => typeof value === 'string' ? value.replace(/&(?:#(?:x[0-9a-f]+|\d+)|[a-z][a-z0-9]+);/gi, entity => {
    entityDecoder.innerHTML = entity;
    return entityDecoder.value;
  }) : value;
  const mount = root => {
    if (root.dataset.wsMounted) return;
    root.dataset.wsMounted = 'true';
    const form = root.querySelector('form');
    const content = root.querySelector('[data-ws-form-content]');
    const success = root.querySelector('[data-ws-success]');
    const strings = Object.fromEntries(Object.entries(JSON.parse(root.querySelector('[data-ws-strings]').textContent)).map(([key, value]) => [key, decodeTranslation(value)]));
    const key = 'dg-wholesale-pending:' + location.pathname;
    const clearSaved = () => { try { sessionStorage.removeItem(key); } catch {} };
    if (root.querySelector('[data-ws-server-success]')) {
      let pending;
      try { pending = JSON.parse(sessionStorage.getItem(key) || 'null'); } catch {}
      const recent = pending && Date.now() - pending.at < 30 * 60 * 1000;
      content.hidden = true;
      success.hidden = false;
      clearSaved();
      success.focus();
      const checkout = root.querySelector('[data-ws-checkout]');
      if (checkout) {
        const wanted = recent && pending.checkoutVariant === root.dataset.trialVariant;
        checkout.hidden = recent && !wanted;
        const checkoutForm = checkout.querySelector('form');
        const button = checkout.querySelector('button');
        const status = checkout.querySelector('[data-ws-checkout-status]');
        let opening = false;
        const openCheckout = async () => {
          if (opening) return;
          opening = true;
          button.disabled = true;
          status.textContent = strings.checkout_loading;
          const variant = root.dataset.trialVariant;
          const base = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
          try {
            const cartResponse = await fetch(base + 'cart.js', { credentials: 'same-origin', signal: AbortSignal.timeout(15000) });
            if (!cartResponse.ok) throw new Error('Cart unavailable');
            const cart = await cartResponse.json();
            // Reading first makes retries safe after a slow or interrupted add request.
            if (!cart.items?.some(item => String(item.variant_id) === variant && item.quantity > 0 && !item.selling_plan_allocation)) {
              const response = await fetch(base + 'cart/add.js', {
                method: 'POST', credentials: 'same-origin', signal: AbortSignal.timeout(15000),
                headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                body: JSON.stringify({ items: [{ id: variant, quantity: 1, properties: { _source: 'Wholesale brochure /start' } }] })
              });
              if (!response.ok) throw new Error('Trial pack unavailable');
              const added = await response.json();
              if (!added.items?.some(item => String(item.variant_id || item.id) === variant && item.quantity > 0)) throw new Error('Trial pack not confirmed');
            }
            window.location.assign(checkoutForm.querySelector('[name="return_to"]').value);
          } catch {
            status.textContent = strings.checkout_error;
            button.disabled = false;
            opening = false;
          }
        };
        checkoutForm.addEventListener('submit', event => { event.preventDefault(); openCheckout(); });
        if (wanted) {
          success.querySelector('h2').textContent = checkout.querySelector('h3').textContent;
          success.querySelector('ol').hidden = true;
          success.querySelector('h3').hidden = true;
          success.querySelector('.ws-primary').hidden = true;
          openCheckout();
        }
      }
      return;
    }
    const steps = [...root.querySelectorAll('[data-ws-step]')];
    const progress = root.querySelector('[data-ws-progress]');
    const error = root.querySelector('[data-ws-error]');
    const submit = root.querySelector('[data-ws-submit]');
    const rows = [...root.querySelectorAll('[data-ws-product]')];
    const field = name => root.querySelector(`[data-ws-field="${name}"]`);
    const value = name => field(name)?.value.trim() || '';
    const contactInput = field('contact');
    const deliveryEmail = root.querySelector('[data-ws-delivery-email]');
    const deliveryPhone = root.querySelector('[data-ws-delivery-phone]');
    const followUp = root.querySelector('[data-ws-follow-up]');
    const contactPattern = new RegExp('^(?:' + contactInput.pattern + ')$');
    const syncContact = () => {
      const contact = value('contact');
      const valid = contactPattern.test(contact);
      const isEmail = valid && contact.includes('@');
      const isPhone = valid && !isEmail;
      contactInput.setCustomValidity(contact && !valid ? contactInput.title : '');
      deliveryEmail.value = isEmail ? contact : deliveryEmail.dataset.fallback;
      deliveryPhone.value = isPhone ? contact : '';
      deliveryPhone.disabled = !isPhone;
      followUp.value = isEmail ? 'Email the customer at ' + contact : isPhone ? 'Phone the customer at ' + contact + '. No customer email was provided. The email header uses our store inbox for delivery; do not reply to that address.' : 'Use the customer contact field.';
      return { contact, isEmail, isPhone };
    };
    const mode = () => root.querySelector('[data-ws-mode]:checked')?.value || 'information';
    const money = (cents, currency = 'USD') => new Intl.NumberFormat(root.dataset.locale || 'en-US', { style: 'currency', currency }).format(cents / 100);
    const trialCurrency = root.dataset.currency || 'USD';
    const canCheckout = Boolean(root.dataset.trialVariant);
    let current = 0;
    let sending = false;
    let timer;
    form.noValidate = true;
    progress.hidden = false;
    root.querySelectorAll('[data-ws-next],[data-ws-back],[data-ws-nav],[data-ws-recap],[data-ws-autonote]').forEach(el => el.hidden = false);
    const show = (index, focus = true) => {
      clearTimeout(timer);
      current = index;
      steps.forEach((step, i) => step.hidden = i !== index);
      [...progress.querySelectorAll('li')].forEach((item, i) => {
        item.classList.toggle('is-done', i < index);
        if (i === index) item.setAttribute('aria-current', 'step');
        else item.removeAttribute('aria-current');
      });
      root.querySelector('[data-ws-progress-fill]').style.width = `${(index + 1) * 100 / 3}%`;
      root.querySelector('[data-ws-announcement]').textContent = strings.progress.replace(/{{\s*current\s*}}/g, index + 1);
      root.querySelector('.ws-form-card').classList.toggle('is-advanced', index > 0);
      root.querySelector('[data-ws-recap-contact]').textContent = value('contact');
      error.hidden = true;
      if (focus) {
        steps[index].querySelector('h2').focus({ preventScroll: true });
        root.querySelector('.ws-form-card').scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    };
    const invalid = scope => {
      contactInput.value = value('contact');
      syncContact();
      return [...scope.querySelectorAll('input,textarea,select')].find(input => {
        if (input.disabled) return false;
        if (input.required && !input.value.trim()) input.value = '';
        return !input.checkValidity();
      });
    };
    const validateStep = index => {
      const bad = invalid(steps[index]);
      if (!bad) return true;
      bad.setAttribute('aria-invalid', 'true');
      bad.focus();
      bad.reportValidity();
      return false;
    };
    const selection = () => rows.map(row => {
      const tier = row.querySelector('[data-ws-tier]').value;
      const quantityInput = row.querySelector('[data-ws-quantity]');
      const cases = Math.max(0, Math.min(50, Math.floor(Number(quantityInput.value) || 0)));
      return { id: row.dataset.productId, title: row.dataset.title, tier, cases, units: cases * (tier === 'full' ? 100 : 50), price: Number(row.dataset[tier]) || 0 };
    }).filter(item => item.cases > 0);
    const updateOrder = () => {
      const choice = mode();
      root.querySelector('[data-ws-catalog]').hidden = choice !== 'custom';
      root.querySelector('[data-ws-trial]').hidden = choice !== 'trial';
      rows.forEach(row => {
        const qty = row.querySelector('[data-ws-quantity]');
        const tier = row.querySelector('[data-ws-tier]');
        row.querySelectorAll('input,select').forEach(input => input.disabled = choice !== 'custom');
        row.querySelector('[data-ws-minus]').disabled = Number(qty.value) <= 0;
        row.querySelector('[data-ws-plus]').disabled = Number(qty.value) >= 50;
        row.querySelector('[data-ws-unit]').textContent = money(Number(row.dataset[tier.value]) || 0);
      });
      const total = choice === 'trial' ? Number(root.dataset.trialTotal) : selection().reduce((sum, item) => sum + item.units * item.price, 0);
      root.querySelector('[data-ws-total]').hidden = choice === 'information';
      const buying = choice === 'trial' && canCheckout;
      root.querySelector('[data-ws-total-number]').textContent = money(total, buying ? trialCurrency : 'USD');
      root.querySelector('[data-ws-total-currency]').textContent = buying ? trialCurrency : 'USD';
      root.querySelector('[data-ws-total-label]').textContent = buying ? strings.checkout_subtotal : strings.estimate;
      root.querySelector('[data-ws-total-note]').textContent = buying ? strings.checkout_note : strings.estimate_note;
      submit.querySelector('span').textContent = buying ? strings.checkout_submit : choice === 'information' ? strings.submit : strings.submit_order;
      error.hidden = true;
    };
    const buildMessage = () => {
      const type = root.querySelector('[data-ws-field="type"]:checked');
      const { contact, isEmail, isPhone } = syncContact();
      const parts = ['DG_WHOLESALE_START — DAMN GOOD WHOLESALE — BROCHURE /start', '', `Name: ${value('name')}`, `Email: ${isEmail ? contact : 'Not provided — phone follow-up requested'}`, `Phone: ${isPhone ? contact : 'Not provided'}`, `Follow-up: ${followUp.value}`, `Business: ${value('business')}`, `Location: ${value('city')}, ${value('region')}`, `Business type: ${type?.value || 'Not specified'}`, `Website / social: ${value('website') || 'Not provided'}`, ''];
      if (mode() === 'information') parts.push('REQUEST: Wholesale information only. No order requested.');
      if (mode() === 'trial') {
        if (canCheckout) {
          parts.push(`CHECKOUT INTENT: 1 × ${root.dataset.trialTitle || 'Trial Pack'}`, `Shopify variant: ${root.dataset.trialVariant}`, `Displayed product price: ${money(Number(root.dataset.trialTotal), trialCurrency)} ${trialCurrency}`, 'The customer chose to continue to Shopify checkout. This email does NOT confirm payment. Verify the paid order in Shopify before fulfillment.');
        } else {
          parts.push('REQUEST: Complete trial bundle (10 units of each SKU)');
          rows.forEach(row => parts.push(`10 × ${row.dataset.title} @ ${money(Number(row.dataset.trial))} / unit = ${money(Number(row.dataset.trial) * 10)}`));
          parts.push(`Estimated product subtotal: ${money(Number(root.dataset.trialTotal))} USD`);
        }
      }
      if (mode() === 'custom') {
        parts.push('REQUEST: Custom wholesale order');
        selection().forEach(item => parts.push(`${item.title}: ${item.cases} × ${item.tier === 'full' ? '100-unit full' : '50-unit half'} case = ${item.units} units @ ${money(item.price)} / unit = ${money(item.units * item.price)}`));
        parts.push(`Estimated product subtotal: ${money(selection().reduce((sum, item) => sum + item.units * item.price, 0))} USD`);
      }
      parts.push('', 'This is a request, not a paid or confirmed order. Confirm availability, final pricing, shipping and tax with the customer.', '', `Notes: ${value('notes') || 'None'}`);
      return parts.join('\n');
    };
    const savePending = () => {
      try {
        const values = [...form.querySelectorAll('input,select,textarea')].filter(el => el.name.startsWith('contact[') && !el.matches('[data-ws-delivery-email],[data-ws-delivery-phone],[data-ws-follow-up]')).map(el => ({ name: el.name, value: el.value, checked: el.checked, type: el.type }));
        sessionStorage.setItem(key, JSON.stringify({ at: Date.now(), values, checkoutVariant: mode() === 'trial' && canCheckout ? root.dataset.trialVariant : null }));
      } catch {}
    };
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || 'null');
      if (saved && Date.now() - saved.at < 30 * 60 * 1000) {
        const savedContact = saved.values?.find(item => item.name === 'contact[Phone or email]') || saved.values?.find(item => item.name === 'contact[email]') || saved.values?.find(item => item.name === 'contact[Phone]');
        if (savedContact) contactInput.value = savedContact.value;
        for (const item of saved.values || []) {
          const matches = [...form.elements].filter(el => el.name === item.name && !el.matches('[data-ws-delivery-email],[data-ws-delivery-phone],[data-ws-follow-up]'));
          if (item.type === 'radio') matches.forEach(el => { if (el.value === item.value) el.checked = item.checked; });
          else if (matches[0] && item.name !== 'contact[Source]') matches[0].value = item.value;
        }
        current = 2;
      } else clearSaved();
    } catch { clearSaved(); }
    root.addEventListener('click', event => {
      if (event.target.closest('[data-ws-next]') && validateStep(current)) show(Math.min(2, current + 1));
      if (event.target.closest('[data-ws-back]')) show(Math.max(0, current - 1));
      if (event.target.closest('[data-ws-edit]')) show(0);
      const change = event.target.closest('[data-ws-plus],[data-ws-minus]');
      if (change) {
        const input = change.closest('[data-ws-product]').querySelector('[data-ws-quantity]');
        input.value = Math.max(0, Math.min(50, (Number(input.value) || 0) + (change.hasAttribute('data-ws-plus') ? 1 : -1)));
        updateOrder();
      }
    });
    root.addEventListener('input', event => {
      event.target.removeAttribute('aria-invalid');
      if (event.target === contactInput) syncContact();
      clearTimeout(timer);
      if (event.target.matches('[data-ws-quantity]')) updateOrder();
    });
    root.addEventListener('change', event => {
      if (event.target.matches('[data-ws-mode],[data-ws-tier]')) updateOrder();
      if (event.target.matches('[data-ws-quantity]')) {
        event.target.value = Math.max(0, Math.min(50, Math.floor(Number(event.target.value) || 0)));
        updateOrder();
      }
      if (event.target.matches('[data-ws-field="type"]') && current === 1 && !invalid(steps[1])) {
        timer = setTimeout(() => { if (current === 1) show(2); }, 350);
      }
    });
    form.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.tagName === 'INPUT' && event.target.type !== 'radio' && current < 2) {
        event.preventDefault();
        if (validateStep(current)) show(current + 1);
      }
    });
    form.addEventListener('submit', event => {
      if (sending) { event.preventDefault(); return; }
      if (current < 2) { event.preventDefault(); if (validateStep(current)) show(current + 1); return; }
      for (let i = 0; i < steps.length; i++) {
        if (invalid(steps[i])) { event.preventDefault(); show(i); validateStep(i); return; }
      }
      if (mode() === 'custom' && !selection().length) {
        event.preventDefault(); error.textContent = strings.catalog_error; error.hidden = false; error.scrollIntoView({ block:'center' }); return;
      }
      root.querySelector('[data-ws-message]').value = buildMessage();
      savePending();
      if (window.Shopify?.designMode) { event.preventDefault(); error.textContent = strings.editor_only; error.hidden = false; return; }
      sending = true;
      submit.setAttribute('aria-busy', 'true');
      submit.querySelector('span').textContent = strings.submitting;
      setTimeout(() => { sending = false; submit.removeAttribute('aria-busy'); updateOrder(); }, 15000);
    });
    window.addEventListener('pageshow', () => { sending = false; submit.removeAttribute('aria-busy'); updateOrder(); });
    updateOrder();
    show(current, false);
  };
  document.querySelectorAll('[data-ws-root]').forEach(mount);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-ws-root]').forEach(mount));
})();
